import { createSelector } from '@reduxjs/toolkit';
import { selectEstateType } from 'shared/selectors/jsonQuery';
import { EEstateType } from '../../../../packages/api-models/common/json_query';

const OPTIONS = [
  { label: 'В аренде', value: EEstateType.Rent },
  { label: 'В собственности', value: EEstateType.Owned },
];

export const selectEstateTypeFilter = createSelector(selectEstateType, value => ({
  label: 'Недвижимость',
  options: OPTIONS,
  value: value && value.length > 0 ? value : [null],
}));
